export default __webpack_public_path__ + "static/media/Seller_Reading2.873f9a7f.png";